import React from 'react';
import PropTypes from 'prop-types';
// Components & Utils
// UI
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

/**
 * @function SelectInput
 * @author RCH010
 * @version 1.0
 * @description a description of the component
 * @param {String} something short description of prop
 * @returns {JSX}
 */
const SelectInput = ({
  register,
  registerName,
  label,
  options,
  optionsKeys,
  defaultValue,
  formControlProps,
  validations,
  ...restOfProps
}) => {
  return (
    <FormControl color='secondary' {...formControlProps}>
      <InputLabel id={`select-${registerName}`}>{label}</InputLabel>
      <Select
        color='secondary'
        label={label}
        labelId={`select-${registerName}`}
        variant='outlined'
        defaultValue={defaultValue}
        {...register(registerName, {
          required: true,
          ...validations,
        })}
        MenuProps={{
          sx: { '& .MuiMenu-paper': { backgroundColor: '#2D1E5A' } },
        }}
        {...restOfProps}>
        {options.map((option) => (
          <MenuItem
            key={option[optionsKeys.id]}
            value={option[optionsKeys.value]}>
            {option[optionsKeys.label]}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

SelectInput.defaultProps = {
  something: '',
};

SelectInput.propTypes = {
  something: PropTypes.string,
};

export default SelectInput;
